import React from 'react';
import styled from 'styled-components';
import WorkTagStation from './WorkTagStation';
import FilterStation from './FilterStation';
import WorkTopBar from './WorkTopBar';
import WorkTopBarMobile from './mobile/WorkTopBarMobile';
import MobileConvertWrapper from '../../shared/component/MobileConvertWrapper';


const WorkMetaStation: React.FC = () => {
  return (
    <WorkMetaStationContainer>
      <WorkTagStation />
      <RightMetaGroup>
        <FilterStation />
        <MobileConvertWrapper
          onlyMobileChildren={<WorkTopBarMobile />}
          onlyNotMobileChildren={<WorkTopBar />}
        />
      </RightMetaGroup>
    </WorkMetaStationContainer>
  );
}

export default WorkMetaStation;

const WorkMetaStationContainer = styled.div`
  width: 100%;
  height: calc(9.8vh);
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 5vw;
  margin-bottom: 4px;
`;

const RightMetaGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 6px;
`;